import * as React from 'react';

import type {EmailAutomation as EmailAutomationFragment} from 'nutshell-graphql-types';

import {Delay, SendFrom} from '../rows';

import styles from './sales-automation-card-email-nutshell-sequence-template.module.css';

type Props = {
    emailAutomation: EmailAutomationFragment;
};

function getSubtitle(emailAutomation: EmailAutomationFragment) {
    const {exitsStage, emailList, sendUntilClose} = emailAutomation;

    if (!emailList) return null;

    if (exitsStage) {
        return (
            <span>
                If no reply, stop when the lead exits <strong>{exitsStage.name}</strong>
            </span>
        );
    }

    return sendUntilClose
        ? 'Keep sending until lead closes'
        : 'Keep sending until reply is received';
}

/*
 * Component that represents a email card on the sales process. This card
 * can span multiple "columns" in the board UI, depending on the
 * `emailAutomation.exitsStage.id` property
 */
export function SalesAutomationCardEmailNutshellSequenceTemplate(props: Props) {
    const {exitsStage, emailList} = props.emailAutomation;

    return (
        <React.Fragment>
            <div className={exitsStage ? styles['card-border'] : styles['card-border--striped']} />
            <div className={styles['title-container']}>
                <div className={styles.title}>
                    {emailList ? (
                        <span>
                            Start sending: <strong>{emailList.name}</strong>
                        </span>
                    ) : (
                        <span className={styles['missing-list']}>
                            Oh no! We couldn’t find the sequence.
                        </span>
                    )}
                </div>
                <div className={styles.subtitle}>{getSubtitle(props.emailAutomation)}</div>
                <Delay
                    delay={props.emailAutomation.delay}
                    entersStage={props.emailAutomation.entersStage}
                />
                <SendFrom sendFromUser={props.emailAutomation.sendFromUser} />
            </div>
        </React.Fragment>
    );
}
